import { Typography } from '@mui/material';
import { FeatureFlag } from '@ps/web-core-enums';
import { useFeature } from '@ps/web-core-store';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { Field } from 'react-final-form';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import createSingleton from '../../../../hooks/useSingleton';
import Container from '../../../Container/Container';
import SumSubField from '../../../SumSubField/SumSubField';
import TransitionProgressPrompt from '../../../TransitionProgressPrompt/TransitionProgressPrompt';
import useRmfFirstScreen from '../../hooks/useRmfFirstScreen';

import {
  TXTCLI_Continue_to_next_step,
  TXTCLI_Identity_check,
  TXTCLI_Welcome_to_XXBrandXX_N0,
  TXTCLI_Your_login_details_have_been_s_ELL
} from './RMFSumSub.messages.json';

const [getValue, setValue] = createSingleton(false);

const RMFSumSub: React.FC = () => {
  const isSwcSignupRmfEcoEransitionTwo = useFeature(FeatureFlag.SwcSignupRmfEcoEransitionTwo);
  const userId = useSelector(select.account.getUserId);
  const isFirstScreen = useRmfFirstScreen();
  const hasBeenShown = getValue();

  return (
    <Container
      pageTopTitle={<Translation {...TXTCLI_Identity_check} />}
      headerProps={{ title: <Translation {...TXTCLI_Identity_check} />, buttons: { back: false } }}
      page={RMFSumSub}
    >
      <Field name="sumSubVerification">
        {({ input: { onChange } }) => (
          <SumSubField
            onSuccess={() => onChange({ pased: true })}
            onFailed={() => onChange({ pased: false })}
          />
        )}
      </Field>
      {isFirstScreen && isSwcSignupRmfEcoEransitionTwo && (
        <TransitionProgressPrompt
          title={{ translation: TXTCLI_Welcome_to_XXBrandXX_N0, values: { 0: userId } }}
          primaryButton={{ translation: TXTCLI_Continue_to_next_step }}
          onPrimaryButtonClick={() => setValue(!hasBeenShown)}
        >
          <Typography>
            <Translation {...TXTCLI_Your_login_details_have_been_s_ELL} />
          </Typography>
        </TransitionProgressPrompt>
      )}
    </Container>
  );
};

RMFSumSub.displayName = 'RMFSumSub';

export default RMFSumSub;
